<template>
  <div class="accounts page">
    <Menu />
    <RouteStepper :steps="steps" />
    <div class="md-layout">
        <div class="md-layout-item md-size-10"></div>
        <div class="md-layout-item md-size-80">
           <div class="projectTable" >
                <div class="accounts__new-btn">
                    <CreateCompany />
                </div>
                
                <md-table v-if="creative_companies.length > 0" v-model="creative_companies" md-sort="name" md-sort-order="asc" md-card md-fixed-header>
                    <md-table-row slot="md-table-row" slot-scope="{ item }" style>
                        <md-table-cell md-label="Creative Company name">
                        {{ item.name }} 
                        
                        </md-table-cell>
                    </md-table-row>
                </md-table>
                <div class="accounts__new-btn" v-if="refreshkey >= 1">
                    
                    <InviteAccount :key="refreshkey"  :type="'account'" :title="'Invite account'" :creative_companies="creative_companies"/>
                </div>
                
                <md-table v-if="accounts" v-model="accounts" md-sort="name" md-sort-order="asc" md-card md-fixed-header>
                    <md-table-row slot="md-table-row" slot-scope="{ item }" style>
                        <md-table-cell md-label="Account name">
                        {{ item.name }} 
                        
                        </md-table-cell>
                        <md-table-cell md-label="E-mail">
                        {{ item.email }} 
                        </md-table-cell>
                        <md-table-cell md-label="Invation Status">{{ (item.email_validated) ? 'Invited' : 'Active'}}</md-table-cell>
                        <md-table-cell md-label="Action"></md-table-cell>
                    </md-table-row>
                </md-table>

                <div class="accounts__new-btn" v-if="refreshkey >= 1">
                    
                    <InviteAccount :key="refreshkey" :type="'designer'" :title="'Invite designer'" :creative_companies="creative_companies"/>
                </div>
                <md-table v-if="designers" v-model="designers" md-sort="name" md-sort-order="asc" md-card md-fixed-header>
                    <md-table-row slot="md-table-row" slot-scope="{ item }" style>
                        <md-table-cell md-label="Account name">
                        {{ item.name }} 
                        
                        </md-table-cell>
                        <md-table-cell md-label="E-mail">
                        {{ item.email }} 
                        </md-table-cell>
                        <md-table-cell md-label="Invation Status">{{ (item.email_validated) ? 'Invited' : 'Active'}}</md-table-cell>
                        <md-table-cell md-label="Action"></md-table-cell>
                    </md-table-row>
                </md-table>
            </div>            
        </div>        
    </div>
  </div>
</template>
<script>
import Menu from '@/components/Menu.vue'
import RouteStepper from '@/components/RouteStepper';
import InviteAccount from '@/components/pagesComponents/accounts/InviteAccount.vue';
import CreateCompany from '@/components/pagesComponents/accounts/CreateCreativeCompany.vue';
import viewMI from '@/mixins/viewMI.js'
export default {
    data: function(){
        return{
            refreshkey : 0,
            accounts: false,
            designers: false,
            creative_companies: [],
             steps: [
                {'name':'Accounts',path: "/accounts"},
            ],
        }
    },
    mixins:[viewMI],
    components:{
        InviteAccount,CreateCompany,
         Menu,
          RouteStepper,
             
    },    
    methods:{
        userReady(){
            this.refreshCreativeCompany();
            this.refreshAccounts();
            this.refreshDesigners();
            this.user_ready = true;
            
        },
        refreshCreativeCompany(){
            var _this = this;
            _this.get('creative_company',{},function(resp){
                _this.creative_companies = resp.data.creative_company;
                _this.refreshkey++;
                _this.$forceUpdate();
            })
        },
        refreshAccounts(){
            var _this = this;
            _this.get('user',{params:{
                where: [['where','user_type','account']]
            }},function(resp){
                _this.accounts = resp.data.user;
                _this.$forceUpdate();
            })
        },
        refreshDesigners(){
            var _this = this;
            _this.get('user',{params:{
                where: [['where','user_type','designer']]
            }},function(resp){
                _this.designers = resp.data.user;
                _this.$forceUpdate();
            })
        }
    }
}
</script>